import { useLayoutEffect, useMemo } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { setClientDefaults } from "./api/client";

export const RootRoute: React.FC = () => {
  const [params] = useSearchParams();

  const baseUrl = useMemo(() => getBaseUrl(), []);
  const accountId = useMemo(() => getAccountId(params), [params]);

  useLayoutEffect(() => {
    setClientDefaults(baseUrl, accountId);
  }, [baseUrl, accountId]);

  return <Outlet />;
};

function getBaseUrl(): string {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  if (window.document.referrer) {
    return new URL(window.document.referrer).origin;
  }

  return "";
}

function getAccountId(params: URLSearchParams): string {
  return params.get("account") ?? import.meta.env.VITE_ACCOUNT_ID;
}
